/// This file was generated DO NOT MODIFY
/// Source: EstimateRowType.cs
/// Tool: http://frhagn.github.io/Typewriter/pages/documentation.html

export enum EstimateRowTypeEnum {
  Project = 'Project', //0
  Level1 = 'Level1', //1
  Level2 = 'Level2', //2
  Department = 'Department', //3
  Category = 'Category', //4
  
}
